import { takeEvery, select, put, call, delay, fork } from "@redux-saga/core/effects";
import {
  START_IR_SIMULATION,
} from '../actionType';
import {
  updateMultiSimulationInfo,
} from '../action'
import { IR_EXPLORER, SIGN_OFF_TEMPLATE } from '@/constants/treeConstants';
import { simulationIRPromise } from '@/services/Cascade/IRExplorer/IRCtrl';
import { VERIFY_RUNNING, WAITING } from '@/constants/verificationStatus';
import { openTabFooter } from "../../../../MonitorStore/action";
import { getInterfaceWorkStatus } from '@/services/project';
import { getStackupErrorCheck, startNewWorkflow } from '../simulationSaga';
import { initSimulationInfo } from '../action';
import { checkVerificationStatus } from '@/services/workflow/workflow';
import { getCascadeSimulationLog } from '@/services/Cascade/simulation/simulationCtrl';
import { updateIRResultExist } from '../../IRExplorer/action'
import { updateSimulationLoading } from "../../project/action";
import { updateErrorToTemplate } from "../../SignOffTemplate/signOffTemplateSaga";
import CascadeChannels from "../../../../../services/Cascade/DB/cascadeChannels";
import { updateSignOffTemplateListStatus } from "../../SignOffTemplate/action";

function* _startIRSimulation(action) {
  let { id, verificationId, designId, IRTableData, signOffId } = action;
  const { CascadeReducer: { IR: { verificationId: _verificationId, designId: _designId, IRExplorerInfo: { IRTableData: _IRTableData } }, project: { openProjectId } } } = yield select();
  verificationId = verificationId ? verificationId : _verificationId
  designId = designId ? designId : _designId
  IRTableData = IRTableData ? IRTableData : _IRTableData
  try {
    if (!IRTableData.length) {
      return;
    }
    // get IR status
    const promise = yield call(checkVerificationStatus, verificationId);
    if (promise && promise.status) {
      if (promise.status === VERIFY_RUNNING || promise.status === WAITING) {
        //running or waiting return
        return
      }
    }

    // start simulation
    yield put(openTabFooter());
    //stackup error check
    const stackupError = yield call(getStackupErrorCheck, { designId, verificationId });
    if (stackupError && stackupError.length) {
      return;
    }

    yield put(updateMultiSimulationInfo({
      verificationId,
      info: {
        startMsg: "==> Prepare Extraction data...",
        log: null,
        monitor: null,
        endMsg: null
      }
    }))
    yield call(simulationIRPromise, verificationId);
    const interfaceStatus = yield call(getInterfaceWorkStatus, verificationId);
    yield put(updateIRResultExist({ id: verificationId, exist: false }))
    if (interfaceStatus && interfaceStatus.length > 0) {
      if (signOffId) {
        const list = CascadeChannels.getList(SIGN_OFF_TEMPLATE, openProjectId);
        yield put(updateSignOffTemplateListStatus(list, openProjectId));
      }

      yield fork(startNewWorkflow, {
        verificationId,
        interfaceStatus,
        key: IR_EXPLORER
      })
      return
    } else {
      if (signOffId) {
        //if ir created by sign-off template, update error message to sign-off template
        yield call(updateErrorToTemplate, {
          openProjectId,
          id: verificationId,
          _signOffId: signOffId,
          error: "Simulation failed!",
          type: IR_EXPLORER
        })
        const list = CascadeChannels.getList(SIGN_OFF_TEMPLATE, openProjectId);
        yield put(updateSignOffTemplateListStatus(list, openProjectId));
      }
      // _initSimulationInfo 
      yield put(initSimulationInfo)
    }
  } catch (error) {
    console.error(error);
    yield delay(1000);
    let log = yield call(getCascadeSimulationLog, verificationId);
    const errorLog = error && Object.prototype.toString.call(error) === '[object String]' ?
      error.split('\n').map(err => err ? `==> ${err}\n` : '') : '';
    yield put(updateMultiSimulationInfo({
      verificationId,
      info: {
        startMsg: errorLog,
        log: log,
        monitor: null,
        endMsg: null
      }
    }))

    if (signOffId) {
      //if ir created by sign-off template, update error message to sign-off template
      yield call(updateErrorToTemplate, {
        openProjectId,
        id: verificationId,
        _signOffId: signOffId,
        error: "Simulation failed!",
        type: IR_EXPLORER
      })
      const list = CascadeChannels.getList(SIGN_OFF_TEMPLATE, openProjectId);
      yield put(updateSignOffTemplateListStatus(list, openProjectId));
    }
  } finally {
    yield put(updateSimulationLoading(false))
  }
}

function* IRSimulationSaga() {
  yield takeEvery(START_IR_SIMULATION, _startIRSimulation);
}

export default IRSimulationSaga;